<template>
  <tw-container>
    <div class="mt-10">
      <h2>
        <router-link :to="{name:'support-requests-index-page'}">
          <icon icon="chevron-left" />
        </router-link> Support Request #{{ supportRequestId }}
      </h2>
      <div class="clearfix mb-2" />
      <template v-if="supportRequest">
        <div class="grid grid-cols-12 gap-10">
          <div class="col-span-9">
            <div class="h-100 overflow-auto">
              <div class="  border-gray-200 bg-white p-6">
                <div class="float-right">
                  <tw-badge class="float-right mr-1" variant="amber">
                    Submitted:  {{ $filters.formatDate(supportRequest.created_at) }}
                  </tw-badge>
                  <tw-badge v-if="supportRequest.closed_at" class="float-right mr-1" variant="green">
                    Closed at:  {{ $filters.formatDate(supportRequest.closed_at) }}
                  </tw-badge>
                  <tw-badge v-if="supportRequest.user" class="float-right mr-1" variant="amber">
                    <icon icon="user" /> {{ supportRequest.user.name }}
                  </tw-badge>
                  <tw-badge class="float-right mr-1" :variant="variantStatus">
                    {{ $filters.formatString(supportRequest.status) }}
                  </tw-badge>
                </div>
                <div class="text-semibold border-1" v-html="supportRequest.message" />
                <div v-if="supportRequest.user">
                  <user-auto-login-button :redirect-url="supportRequest.url" size="sm" :user="supportRequest.user" class="mt-2" />
                </div>
              </div>

              <tw-list-group v-if="supportRequestMessages && supportRequestMessages.length > 0" class="mt-4">
                <support-request-message-list-group-item v-for="supportRequestMessage in supportRequestMessages" :key="'support-request-message-key-' + supportRequestMessage.id" :support-request-message="supportRequestMessage" />
              </tw-list-group>
              <div v-else>
                <h2 class="text-center my-10">
                  No replies yet
                </h2>
              </div>
              <support-request-add-message class="mt-2" :support-request="supportRequest" />
            </div>
          </div>
          <div class="col-span-3">
            <support-request-actions-dropdown v-if="loggedInUser.admin && supportRequest" block :support-request="supportRequest" />
            <div class="mt-10">
              <a v-if="supportRequest.screenshot_upload" target="_blank" :href="supportRequest.screenshot_upload.url">
                <tw-img fluid :src="supportRequest.screenshot_upload.url" thumbnail />
              </a>
              <h4 v-else class="text-center">
                No screenshot
              </h4>
            </div>
          </div>
        </div>
      </template>
    </div>
  </tw-container>
</template>

<script>
import SupportRequestActionsDropdown from '../../components/support-requests/support-request-actions-dropdown.vue'
import SupportRequestAddMessage from '../../components/support-requests/support-request-add-message.vue'
import SupportRequestMessageListGroupItem from '../../components/support-requests/support-request-message-list-group-item.vue'
import { useSupportRequestMessagesStore } from '@/stores/supportRequestMessages.js'
import { useSupportRequestsStore } from '@/stores/supportRequests.js'
import TwBadge from '@/components/generic/tw-badge.vue'
import TwContainer from '@/components/generic/tw-container.vue'
import loggedInUserMixin from '@/mixins/loggedInUserMixin.js'
import TwCard from '@/components/generic/tw-card.vue'
import TwListGroup from '@/components/generic/list-group/tw-list-group.vue'
import TwImg from '@/components/images/tw-img.vue'
import UserAutoLoginButton from '@/components/user/user-auto-login-button.vue'

export default {
  name: 'SupportRequestPage',
  components: { UserAutoLoginButton, TwImg, TwListGroup, TwCard, TwContainer, TwBadge, SupportRequestMessageListGroupItem, SupportRequestActionsDropdown, SupportRequestAddMessage },
  mixins: [loggedInUserMixin],
  props: {
    supportRequestId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      LoadingFetchingSupportRequest: false
    }
  },
  computed: {
    supportRequest () {
      return useSupportRequestsStore().getItemById(this.supportRequestId)
    },
    supportRequestMessages () {
      return useSupportRequestMessagesStore().getItemsBySupportRequestId(this.supportRequestId)
    },
    variantStatus () {
      const statusesVariants = {
        pending: 'amber',
        in_progress: 'blue',
        closed: 'green'
      }
      return statusesVariants[this.supportRequest.status]
    }
  },
  mounted () {
    this.fetchSupportRequest()
  },
  methods: {
    async fetchSupportRequest () {
      try {
        this.ValidationErrorMessage = null
        this.LoadingFetchingSupportRequest = true
        await useSupportRequestsStore().fetchItemById(this.supportRequestId)
        await useSupportRequestMessagesStore().fetchItems({
          support_request_id: this.supportRequestId
        })
        if (!this.loggedInUser.admin && this.loggedInUser.id !== this.supportRequest.user_id) {
          this.$notify('You do not have permission to view this support request.', 'danger')
          this.$router.push({ name: 'support-requests-index-page' })
        }
        this.LoadingFetchingSupportRequest = false
      } catch (e) {
        console.error(e)
        this.LoadingFetchingSupportRequest = false
        if (e.response) this.ValidationErrorMessage = e.response.data
        throw e
      }
    }
  }
}
</script>

<style scoped>

</style>
